import { Popover, PopoverBody } from 'reactstrap';

type ChefInfoPopoverProps = {
  chef?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
  };
  isOpen: boolean;
  targetId: string;
};


const ChefInfoPopover: React.FC<ChefInfoPopoverProps> = ({ chef, isOpen, targetId }) => {
  if (!chef?.id) return null;

  return (
    <Popover placement="right" isOpen={isOpen} target={targetId}>
      <PopoverBody>
        <p>
          <strong>Name:</strong>{' '}
          {`${chef?.firstName || ''} ${chef?.lastName || 'N/A'}`}
        </p>
        <p>
          <strong>Email:</strong> {chef?.email || 'N/A'}
        </p>
        <p>
          <strong>Phone:</strong> {chef?.phone || 'N/A'}
        </p>
      </PopoverBody>
    </Popover>
  );
};

export default ChefInfoPopover;
